import React from "react";

function Skeleton({ width, height }) {
  return (
    <>
      <div
        className={`${height ? height : "h-10"} ${
          width ? width : "w-40"
        } bg-gray-200 animate-pulse rounded-lg`}
      ></div>
    </>
  );
}

export default Skeleton;
